<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
</div>
<div class="modal-body">
  {{ message | translate}}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="decline()">{{ btnCancelText | translate}}</button>
  <button type="button" class="btn btn-primary" (click)="accept()">{{ btnOkText | translate}}</button>
</div>